<template>
  <div class="intro-banner" :class="{ 'image-loaded': imageLoaded, 'no-image': !heroImage }">
    <div class="image" :style="imageStyle"></div>
    <div class="container">
      <div class="logo">
        <img loading="lazy" :src="logo" alt="Quinta's Figueira" />
      </div>
      <div class="content">
        <div class="disclaimer">{{ $t("ageWarning") }}</div>
        <button @click="isConfirmation" class="btn-border-white mt-3 mb-3">{{ $t("enter") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { mapState, mapActions } from 'vuex';
import InputGetList from '@/classes/InputGetList';
import { API_HELPER } from "@/helpers/api.js";

export default {
  data() {
    return {
      logo: require("@/assets/img/logo-white.png"),
      imageLoaded: false
    };
  },
  mounted() {
    this.initializeHero();
  },
  methods: {
    ...mapActions('heros', ['getList']),
    
    isConfirmation() {
      let inHalfADay = 0.5;
      Cookies.set("ageVerified", "true", {
        expires: inHalfADay,
        secure: true
      });
      this.$emit('isClick');
    },
    initializeHero() {
      // GET list of hero
      const itemsPerPage = 99;
      const currentPage = 1;
      const sorter = 1; // asc
      const propertyName = "id";
      const searchText = '';

      //Make request
      var input = new InputGetList(itemsPerPage, currentPage, sorter, propertyName, searchText);

      // List specific parameters
      input.visible = true;

      this.getList(input);
    }
  },
  computed: {
    ...mapState({
      herosOutput: state => state.heros.listOutput,
    }),
    heroImage() {
      let result = null;

      if (this.herosOutput && this.herosOutput.data && this.herosOutput.data.heroItems && this.herosOutput.data.heroItems.length) {
        // Find the first image of type AgeVerification
        const item = this.herosOutput.data.heroItems.find(obj => obj.types && obj.types.some(typeObj => typeObj.type === 'AgeVerification'));
        result = item && item.image ? API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, item.image]) : null;
      }

      return result;
    },
    imageStyle() {
      return {
        backgroundImage: `url(${this.heroImage})`
      };
    }
  },
  watch: {
    heroImage(newVal) {
      if (newVal) {
        const img = new Image();
        img.onload = () => {
          this.imageLoaded = true;
        };
        img.src = newVal;
      }
    }
  }
};
</script>

<style scoped>
.intro-banner {
  height: 100dvh;
  min-height: 100dvh;
  color: #fff;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.intro-banner::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(360deg, #000, rgba(84, 84, 84, 0.2));
  z-index: 5;
  min-height: 100dvh;
  opacity: 0;
  transition: opacity 0.5s ease;
}

.intro-banner.image-loaded::before {
  opacity: 1;
}

.intro-banner.no-image {
  background-color: #000;
}

.intro-banner.no-image .image {
  background-color: #000;
}

.intro-banner .container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px 20px;
  z-index: 10;
  text-align: center;
  width: 100%;
  max-width: 100%;
}

.intro-banner .image {
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  min-height: 100dvh;
}

.intro-banner .logo {
  margin-bottom: 2rem;
}

.intro-banner .logo img {
  display: block;
  margin: 0 auto;
  height: 300px;
  width: auto;
}

img {
  max-width: 100%;
  height: auto;
}

.intro-banner .content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.intro-banner h2 {
  font-size: 2.5rem;
  line-height: 1.2;
}

.intro-banner .disclaimer {
  font-size: 13px;
  line-height: 1.4;
  text-align: center;
  margin-top: 13.33333px;
}

@media screen and (max-width: 991px) {
  .intro-banner .container {
    padding: 30px 15px;
  }

  .intro-banner .logo img {
    height: 200px;
  }

  .intro-banner h2 {
    font-size: 34px;
    line-height: 1.2;
  }
}
</style>
